import { defaultSize, getViewSizeByClassName, setFittedSize, bound, calculateRealLocation, scrollFromCenterY, getViewSize, setTransformSizes } from "../../canvas/geometry";
export default {
  data() {
    return {
      canvasSize: defaultSize(),
      scroll: 0.5,
      minScroll: 0,
      maxScroll: 1,
      dragStart: null,
      isMousedown: false,
      controlSize: defaultSize()
    }
  },
  computed: {
    // note - view will need to provide an imgSize
    minCenter() {
      return this.canvasSize.h / (2 * this.imgSize.h * this.transform.zoom) || 0.5
    },
    maxCenter() {
      return 1 - this.minCenter;
    }
  },
  methods: {
    updateCanvasSizes() {
      let vs = getViewSizeByClassName("hvf-image-view");
      setFittedSize(vs, vs, this.canvasSize, 8);
      let zcs = getViewSize("hvf-zoom-wrapper");
      setFittedSize(zcs, zcs, this.controlSize);
    },
    realLocation(x, y, transform, imgSize) {
      let offset = { x: 8, y: 8 };
      setTransformSizes(transform, this.canvasSize, imgSize);
      return calculateRealLocation(x, y, offset, transform);
    },
    dragTo(x, y, transform, imgSize){
      let dy = this.dragStart.y - y;
      let centerY = transform.centerY + dy / imgSize.h;
      let scroll = scrollFromCenterY(centerY, this.canvasSize, imgSize, transform);
      this.scroll = bound(scroll, this.minScroll, this.maxScroll);
    },
    initiateDragStart(x, y) {
      this.dragStart = { x, y };
    },
    clearDragStart() {
      this.dragStart = null;
    },
    scrollUp() {
      this.scroll = bound(this.scroll - 0.1, this.minScroll, this.maxScroll);
    },
    scrollDown() {
      this.scroll = bound(this.scroll + 0.1, this.minScroll, this.maxScroll);
    },
    scrollTo(scroll){
      this.scroll = bound(scroll, this.minScroll, this.maxScroll);
    },
    mousedown({e, transform, imgSize}) {
      this.isMousedown = true;
      const { x, y } = this.realLocation(e.offsetX, e.offsetY, transform, imgSize);
      this.initiateDragStart(x, y);
    },
    mousemove({e, transform, imgSize}) {
      if (this.isMousedown){
        const { x, y } = this.realLocation(e.offsetX, e.offsetY, transform, imgSize);
        if (this.dragStart) this.dragTo(x, y, transform, imgSize);
        else this.initiateDragStart(x, y);
      } else this.clearDragStart();
    },
    mouseup() {
      this.clearDragStart();
      this.isMousedown = false;
    },
    mouseout() {
      this.clearDragStart();
      this.isMousedown = false;
    }
  }
}